<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fal fa-pencil-alt dialog-icon"></i>
            <span class="te-title">{{'enquiryBook.changeStatus' | translate}}</span>
        </div>
        <div class="td-cnt-body">
            <span>{{'enquiryBook.changeStatusFor' | translate}} <b>{{enquiryNo}}</b></span>
            <teiasoft-select [isMobile]="isMobile"
                [optionsList]="optionsList!"
                [spaceLabel]="false" [noMinWidth]="true" [defaultValue]="value"
                (onSelected)="onSelected($event)" style="width:100%" [readOnly]="false"></teiasoft-select>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onChangeStatusClick()" class="mr-5" [text]="'commons.save' | translate"  [theme]="theme" [isMobile]="isMobile" [type]="'tb-secondary'"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseChageStatusModal()" class="mr-5" [type]="'tb-cancel'" [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
